import { scheduleApi } from "api/immunization";
import { humanise } from "config/immunizationConstants";
import MasterListScreen from "./common/MasterListScreen";
import ScheduleModal from "./ScheduleModal";

const ScheduleList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={scheduleApi}
    label="Schedule"
    entityLabel="schedule"
    addLabel="Add Schedule"
    tag="immunization-schedule"
    headers={[
      "Name",
      "Code",
      "Type",
      "Anchor",
      "Authority",
      "Status",
      "Action",
    ]}
    keys={[
      "name",
      "code",
      "typeLabel",
      "anchorLabel",
      "issuingAuthority",
      "statusChip",
      "action",
    ]}
    displayName={(item) => item.scheduleName}
    mapRow={(item) => ({
      typeLabel: humanise(item.scheduleType),
      anchorLabel: humanise(item.anchorType),
    })}
    Modal={ScheduleModal}
    searchText={searchText}
  />
);

export default ScheduleList;
